<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <b-card no-body>
          <b-card-body class="border-bottom d-flex align-items-center justify-content-between">
            <h4 class="card-title text-primary m-0">{{ $t('Detail') }} {{ lodash.startCase($t('approval_templates.singular')) }}</h4>
          </b-card-body>
          <b-card-body>
            <div class="row mb-3">
              <div class="col-6">
                <div class="text-muted small mb-1">{{ lodash.startCase($t('approval_templates.name')) }}</div>
                <div>{{ model.name }}</div>
              </div>
              <div class="col-6">
                <div class="text-muted small mb-1">{{ lodash.upperFirst($t('approval_templates.menu')) }}</div>
                <div>{{ approvableTypeLabel }}</div>
              </div>
              <div class="col-6">
                <div class="text-muted small mb-1">{{ lodash.upperFirst($t('approval_templates.status')) }}</div>
                <div>
                  <div>
                     <status-badge 
                      entity="approval_template"
                      type="status"
                      :status="model.is_active ? 'active' : 'inactive'" 
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="mb-2">{{ lodash.startCase($t('approval_templates.approvers')) }}</div>
            <div style="border: 1px solid #dee2e6; border-radius: 8px; overflow: hidden">
              <table class="table table-borderless mb-0">
                <thead style="background-color: #FAFAFA">
                  <tr>
                    <th>{{ lodash.startCase($t('approval_templates.user_name')) }}</th>
                    <th>{{ lodash.startCase($t('approval_templates.level_approver')) }}</th>
                    <th>{{ lodash.startCase($t('approval_templates.condition')) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="step in activeSteps" :key="step.id">
                    <td>{{ (step.approver || {}).name || '-' }}</td>
                    <td>{{ levelLabel(step.level) }}</td>
                    <td>{{ $numeral(parseFloat(step.minimum_amount)).format("$ 0,0.[00]") }}</td>
                  </tr>
                  <tr v-if="!activeSteps.length">
                    <td colspan="3" class="text-center text-muted">{{ $t('no_data') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from '../models/show';
import statusBadge from '@/components/badges/status-badge.vue';

export default {
  extends: ModelShow,
  components: {
    statusBadge
  },
  page: {
    title: "Detail Approval Template",
  },
  props: {
    cardTitle: { default() { return this.lodash.startCase(this.$t('approval_templates.singular')) } },
    resourceRoute: { default: 'approval_templates' },
    modelVariable: { default: 'approval_template' },
    denyDelete: { type: Boolean, default: true },
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('approval_templates.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    approvableTypeLabel() {
      const map = this.$t('approval_templates.approvable_types');
      return map[this.model.approvable_type] || this.model.approvable_type;
    },
    activeSteps() {
      return (this.model.approval_template_steps || [])
        .filter(s => s._action !== 'delete')
        .sort((a, b) => a.level - b.level);
    },
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('approval_templates.plural')),
          href: "/approval_templates",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/approval_templates/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [

      ]
    }
  },
  methods: {
    levelLabel(level) {
      return `${this.$t('approval_templates.level')} ${level} - ${this.$t(`approval_templates.levels.${level}`)}`;
    },
    delete() {
      return this.$axios.delete(`/approval_templates/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/approval_templates/${this.$route.params.key}`, {
        params: {
          with: 'approval_template_steps.approver',
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    }
  }
}
</script>
